<template>
    <div class="pagination">
        <NuxtLink v-if="currentPage > 1" :to="$withLocalePrefix(controlLink(currentPage - 1))" class="item" external>
            <Chevron direction="left" />
        </NuxtLink>
        <span v-else class="item disabled">
            <Chevron direction="left" />
        </span>
        <NuxtLink
            :to="$withLocalePrefix(`${basePath}${locationQueryToQueryString(query)}`)"
            :class="{item: true, active: currentPage === 1}"
            external
        >
            1
        </NuxtLink>
        <template v-for="index in navigationWidth" :key="index">
            <NuxtLink
                v-if="
                    navigationIndex + index - 2 < totalPages &&
                    ((index > 1 && index < navigationWidth) ||
                        (index === 1 && navigationIndex <= 3) ||
                        (index === navigationWidth && navigationIndex === totalPages - 4))
                "
                :to="$withLocalePrefix(paginationLink(index))"
                :class="{item: true, active: currentPage === navigationIndex + index - 2}"
                external
            >
                {{ navigationIndex + index - 2 }}
            </NuxtLink>
            <span
                v-else-if="
                    (index === 1 && navigationIndex > 3) ||
                    (index === navigationWidth && navigationIndex < totalPages - 2 && navigationIndex + index - 2 < totalPages)
                "
                class="item"
            >
                ...
            </span>
        </template>
        <NuxtLink v-if="totalPages > 1" :to="$withLocalePrefix(totalPagesLink)" :class="{item: true, active: currentPage === totalPages}" external>
            {{ totalPages }}
        </NuxtLink>

        <NuxtLink v-if="currentPage < totalPages" :to="$withLocalePrefix(controlLink(currentPage + 1))" class="item" external>
            <Chevron />
        </NuxtLink>
        <span v-else class="item disabled">
            <Chevron />
        </span>
    </div>
</template>

<script lang="ts" setup>
    import {ref, computed} from 'vue';
    import {useRoute} from '@typed-router';
    import Chevron from '~/components/icons/Chevron.vue';
    import {createContentHelpers} from '../composables/contentHelpers';
    const props = defineProps<{
        basePath: string;
        totalPages: number;
        currentPage: number;
    }>();
    const {query} = useRoute();
    const {locationQueryToQueryString} = createContentHelpers();

    const navigationIndex = ref(
        props.currentPage < 3 ? 3 : props.currentPage > props.totalPages - 4 ? Math.max(props.totalPages - 4, 3) : props.currentPage,
    );
    const navigationWidth = 5;

    const paginationLink = (index: number) => `${props.basePath}/${navigationIndex.value + index - 2}${locationQueryToQueryString(query)}`;
    const controlLink = (index: number) => `${props.basePath}/${index}${locationQueryToQueryString(query)}`;
    const totalPagesLink = computed<string>(() => `${props.basePath}/${props.totalPages}${locationQueryToQueryString(query)}`);
</script>

<style lang="scss">
    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: var(--joy-core-spacing-5) 0;
        button {
            &:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
            svg {
                height: 20px;
            }
        }
        .item {
            font-size: var(--joy-font-size-primary-600);
            font-weight: var(--joy-font-weight-bold);
            color: var(--joy-color-neutral-40);
            line-height: 100%;
            display: flex;
            width: 36px;
            justify-content: center;
            padding: var(--joy-core-spacing-2);
            &.active {
                background-color: var(--joy-color-primary-50);
                color: var(--joy-color-neutral-0);
                border-radius: 50px;
            }
            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
    }
</style>
